/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'pip-analytics__page-load',
  'pip-analytics__sub-content',
  'pip-analytics__overlays',
  'pip-analytics__aisle-and-bay',
  'pip-analytics__tooltips',
  'pip-analytics__frequently-bought-together',
  'pip-analytics__feature-based-recommendations',
  'pip-analytics__item-related-groups',
  'pip-analytics__multi-item-add-to-cart',
  'pip-analytics__express_delivery',
  'pip-analytics__appliance',
  'pip-analytics__appliance-bundling',
  'pip-analytics__schedule_furnish_install',
  'pip-analytics__shipping-options',
  'pip-analytics__calculators',
  'addToCartLocationAnalytics',
  'pip-analytics__trackif',
  'pip-analytics__dual-path',
  'pip-analytics__paint-ssku',
  'pip-analytics__automotive',
  'pip-analytics__product_not_found',
  'pip-analytics__instant-checkout',
  'pip-analytics__multi-sku-bulk',
  'pip-analytics__augmented-reality',
  'pip-analytics__add-to-cart',
  'pip-analytics-article_recommendations',
  'pip-analytics__add-to-cart-backorder',
  'pip-analytics__quantity',
  'pip-analytics__cards',
  'pip-analytics__b2b-only'
],
function(
  analyticsPageLoad,
  analyticsSubContent,
  analyticsOverlays,
  analyticsAisleAndBay,
  analyticsTooltips,
  analyticsFrequentlyBoughtTogether,
  analyticsFeatureBasedRecommendations,
  analyticsItemRelatedGroups,
  analyticsMultiItemAddToCart,
  analyticsExpressDelivery,
  analyticsAppliance,
  analyticsApplianceBundling,
  analyticsScheduleFurnishInstall,
  analyticsShippingOptions,
  analyticsCalculators,
  addToCartLocationAnalytics,
  analyticsTrackIf,
  analyticsDualPath,
  analyticsPaintSSKU,
  analyticsAutomotive,
  analyticsProductNotFound,
  analyticsInstantCheckout,
  analyticsMSB,
  analyticsAugmentedReality,
  analyticsAddtoCart,
  analyticsArticleRecommendations,
  analyticsAddtoCartBackorder,
  analyticsQuantity,
  analyticsCard,
  analyticsB2BOnly
){

  return {
    init: function(){
      analyticsPageLoad.init();
      analyticsSubContent.init();
      analyticsOverlays.init();
      analyticsAisleAndBay.init();
      analyticsTooltips.init();
      analyticsFrequentlyBoughtTogether.init();
      analyticsItemRelatedGroups.init();
      analyticsExpressDelivery.init();
      analyticsAppliance.init();
      analyticsApplianceBundling.init();
      analyticsFeatureBasedRecommendations.init();
      analyticsMultiItemAddToCart.init();
      analyticsScheduleFurnishInstall.init();
      analyticsShippingOptions.init();
      analyticsCalculators.init();
      addToCartLocationAnalytics.bind();
      analyticsTrackIf.init();
      analyticsDualPath.init();
      analyticsPaintSSKU.init();
      analyticsAutomotive.init();
      analyticsProductNotFound.init();
      analyticsInstantCheckout.init();
      analyticsMSB.init();
      analyticsAugmentedReality.init();
      analyticsAddtoCart.init();
      analyticsArticleRecommendations.init();
      analyticsAddtoCartBackorder.init();
      analyticsQuantity.init();
      analyticsCard.init();
      analyticsB2BOnly.init();
    }
  }
});

}.call(window));